import React from 'react';
import Autopara from './Autopara';

const images = [
  'https://miro.medium.com/v2/resize:fit:600/1*fOdb_ET1sOd4uZStK4E8HA.jpeg',
  'https://st2.depositphotos.com/1004174/7566/i/450/depositphotos_75664409-stock-photo-programming-concept.jpg',
  'https://fiverr-res.cloudinary.com/images/t_main1,q_auto,f_auto,q_auto,f_auto/gigs/137354077/original/93b698b8b5225bf0ba6e3ebd5d062d71e38a9c33/do-your-java-coding-projects-assignments-remote-worker.jpg',
];

const paragraphText = `
  Java is a class-based, object-oriented programming language that is platform-independent and highly scalable. 
  It’s the backbone of many enterprise applications and Android mobile apps. 
  Java’s strong community, robust tools, and frameworks like Spring Boot make it a top choice for backend and full-stack development.
`;

function AutoparaJava() {
  return <Autopara images={images} text={paragraphText} />;
}

export default AutoparaJava;
